import React, { useRef, useState } from 'react'
import { useHistory, Link } from 'react-router-dom'
import PageHeading from '../pageHeading/PageHeading'
import { useAuth } from '../../../context/AuthContext'


export default function SignUp() {
	const { signup } = useAuth()
	const history = useHistory()
	const emailRef = useRef()
	const passwordRef = useRef()
	const passwordConfirmRef = useRef()
	const [loading, setLoading] = useState(false)

	const handleSubmit = async (event) => {
		event.preventDefault()
		setLoading(true)
		if (passwordRef.current.value !== passwordConfirmRef.current.value) {
			alert('error!')
			return
		}
		try {
			await signup(emailRef.current.value + "@kuf.fi", passwordRef.current.value)
			history.push('/')
		} catch {
			alert('error!')
			setLoading(false)
		}
	}
	return (
		<div className="AppContents">
		<div className="Container">
			<PageHeading heading={'Skapa konto'} />
			<section>
				<div>
					<label>Användarnamn</label>
					<input ref={emailRef} type="text" placeholder="Användarnamn" />
				</div>
				<div>
					<label>Lösenord</label>
					<input
						ref={passwordRef}
						type="password"
						placeholder="Lösenord"
					/>
				</div>
				<div>
					<label>Bekräfta lösenord</label>
					<input
						ref={passwordConfirmRef}
						type="password"
						placeholder="Bekräfta lösenord"
					/>
				</div>
			</section>
			<section>
				<button onClick={(e) => handleSubmit(e)} disabled={loading}>
					Skapa
				</button>
			</section>
			<section>
				har du redan ett konto? <Link to="/signin">Logga in</Link>
			</section>
		</div>
		</div>
	)
}
